import { render, staticRenderFns } from "./InnChip.vue?vue&type=template&id=e92465f8"
import script from "./InnChip.vue?vue&type=script&lang=js"
export * from "./InnChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports